<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Ventas</h3>
      </div>
    </div>
    <div class="card">
      <div class="card__title">
        <h5>Información de la consulta</h5>
        <div class="card__controls">
          <button type="button" @click="consultar" class="btn-info">
            <i class="fa fa-search"></i><span>Consultar</span>
          </button>
        </div>
      </div>
      <div class="card__content">
        <div class="row">
          <div class="col-xs-12 col-md-4">
            <div class="form-field select">
              <div class="select-field">
                <select
                  v-model="form.tipo_fecha"
                  name="tipo_fecha"
                  id="tipo_fecha"
                >
                  <option value="H">Hoy</option>
                  <option value="A">Ayer</option>
                  <option value="P">Personalizado</option>
                </select>
                <label for="tipo_fecha">Tipo de fecha</label>
              </div>
            </div>
          </div>
          <div v-show="form.tipo_fecha === 'P'" class="col-xs-12 col-md-4">
            <div class="form-field">
              <div class="datepicker-field">
                <VueCtkDateTimePicker
                  id="fecha"
                  v-model="form.desde"
                  locale="es"
                  no-label
                  button-now-translation="Ahora"
                  format="YYYY-MM-DD"
                  only-date
                  formatted="YYYY-MM-DD"
                  label="Seleccione fecha..."
                />
                <label>Desde</label>
              </div>
            </div>
          </div>
          <div v-show="form.tipo_fecha === 'P'" class="col-xs-12 col-md-4">
            <div class="form-field">
              <div class="datepicker-field">
                <VueCtkDateTimePicker
                  id="fecha"
                  v-model="form.hasta"
                  locale="es"
                  no-label
                  button-now-translation="Ahora"
                  format="YYYY-MM-DD"
                  only-date
                  formatted="YYYY-MM-DD"
                  label="Seleccione fecha..."
                />
                <label>Hasta</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="grid grid--fit mt-2">
      <button-card
        btn-color="btn-info"
        fa-name="fa-address-card"
        :counter="numeroVisitas"
        ><span style="font-size: 20px">VISITAS</span></button-card
      >
      <button-card
        btn-color="btn-success"
        fa-name="fa-sellsy"
        :counter="numeroVentas"
        ><span style="font-size: 20px">VENTAS</span>
        <strong style="font-size: 20px"
          >({{ moneyFormat(totalVentas) }})</strong
        ></button-card
      >
      <button-card
        btn-color="btn-primary"
        fa-name="fa-calendar"
        :counter="numeroRecaudaciones"
        ><span style="font-size: 20px">RECAUDACIONES</span></button-card
      >
      <button-card
        btn-color="btn-secondary"
        fa-name="fa-money"
        :counter="numeroAbonos"
        ><span style="font-size: 20px">ABONOS</span>
        <strong style="font-size: 20px"
          >({{ moneyFormat(totalAbonos) }})</strong
        ></button-card
      >
    </div>
    <div class="card mt-2">
      <div class="card__title">
        <h5>Mapa de ventas</h5>
        <div class="card__controls">
          <div class="form-inline">
            <label for="mostrar_clientes">
              <input
                type="checkbox"
                v-model="form.mostrar_clientes"
                name="mostrar_clientes"
                id="mostrar_clientes"
                @change="consultar"
              /><span>Mostrar clientes</span>
            </label>
            <label for="mostrar_rutas">
              <input
                type="checkbox"
                v-model="form.mostrar_rutas"
                name="mostrar_rutas"
                id="mostrar_rutas"
                @change="consultar"
              /><span>Mostrar rutas</span>
            </label>
          </div>
        </div>
      </div>
      <div class="card__content">
        <div class="row">
          <div class="col-xs-12 col-md-3">
            <div class="form-field select2">
              <div class="select2-field">
                <v-select
                  @search="searchVendedores"
                  @input="inputVendedores"
                  v-model="selectedVendedores"
                  multiple
                  :options="vendedores"
                  placeholder="Seleccione..."
                  label="descripcion"
                  id="vendedor"
                ></v-select>
                <label for="vendedor">Vendedor(es)</label>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-3">
            <div class="form-field select2">
              <div class="select2-field">
                <v-select
                  @input="inputSupervisores"
                  @search="searchSupervisores"
                  v-model="selectedSupervisores"
                  multiple
                  :options="supervisores"
                  label="nombre"
                  placeholder="Seleccione..."
                  id="supervisor"
                ></v-select>
                <label for="supervisor">Supervisor(es)</label>
              </div>
            </div>
          </div>
          <!-- <div class="col-xs-12 col-md-3">
            <div class="form-field select2">
              <div class="select2-field">
                <v-select
                  @input="inputRecaudadores"
                  @search="searchRecaudadores"
                  v-model="selectedRecaudadores"
                  multiple
                  :options="recaudadores"
                  label="nombre"
                  placeholder="Seleccione..."
                  id="recaudador"
                ></v-select>
                <label for="recaudador">Recaudador(es)</label>
              </div>
            </div>
          </div> -->
          <div class="col-xs-12 col-md-3">
            <div class="form-field select2">
              <div class="select2-field">
                <v-select
                  @input="inputRutas"
                  @search="onSearchRutas"
                  v-model="selectedRutas"
                  label="descripcion"
                  multiple
                  :options="rutas"
                  placeholder="Seleccione..."
                  id="ruta"
                ></v-select>
                <label for="ruta">Ruta(s)</label>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-3">
            <div class="form-field select">
              <div class="select-field">
                <select
                  name="dia_cobro"
                  v-model="form.dia_cobro"
                  id="dia_cobro"
                >
                  <option disabled value="">Seleccione...</option>
                  <option value="1">Lunes</option>
                  <option value="2">Martes</option>
                  <option value="3">Miércoles</option>
                  <option value="4">Jueves</option>
                  <option value="5">Viernes</option>
                  <option value="6">Sábado</option>
                  <option value="7">Domingo</option>
                </select>
                <label for="dia_cobro">Día de cobro</label>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-3">
            <div class="form-field select2">
              <div class="select2-field">
                <v-select
                  id="bodega"
                  v-model="selectedBodega"
                  placeholder="Seleccione..."
                  @input="inputBodega"
                  :options="bodegas"
                  label="descripcion"
                ></v-select>
                <label for="bodega">Sucursal</label>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-3">
            <div class="form-field">
              <button type="button" @click="consultar" class="btn-info">
                <i class="fa fa-refresh"></i>
              </button>
            </div>
          </div>
          <div class="col-xs-12">
            <div style="height: 700px">
              <l-map
                ref="mymap"
                @update:zoom="zoomUpdated"
                @update:center="centerUpdated"
                style="height: 100%; width: 100%"
                :zoom="zoom"
                :center="center"
              >
                <l-tile-layer :url="url"></l-tile-layer>
                <l-circle-marker
                  :key="'radio' + index"
                  v-for="(punto, index) in puntosRutas"
                  :radius="parseFloat(punto.radio)"
                  :lat-lng="[punto.latitud, punto.longitud]"
                  color="red"
                ></l-circle-marker>
                <l-marker
                  :name="punto.descripcion"
                  v-for="(punto, index) in puntosRutas"
                  :key="'punto' + index"
                  :icon="markerIcon"
                  :lat-lng="[punto.latitud, punto.longitud]"
                >
                  <l-tooltip
                    >{{ punto.descripcion }} ({{
                      punto.nombre_ruta
                    }})</l-tooltip
                  >
                  <l-popup>
                    <ul>
                      <li><strong>Punto:</strong> {{ punto.descripcion }}</li>
                      <li><strong>Ruta:</strong> {{ punto.nombre_ruta }}</li>
                      <li><strong>Radio:</strong> {{ punto.radio }}</li>
                      <li><strong>Latitud:</strong> {{ punto.latitud }}</li>
                      <li><strong>Longitud:</strong> {{ punto.longitud }}</li>
                    </ul>
                  </l-popup>
                </l-marker>
                <l-marker
                  :name="cliente.descripcion"
                  v-for="(cliente, index) in clientes"
                  :key="'cliente' + index"
                  :icon="cliente.icon"
                  :lat-lng="[cliente.latitud, cliente.longitud]"
                >
                  <l-tooltip
                    :options="tooltipOptions"
                    >{{ moneyFormat(cliente.saldo) }} ({{
                      cliente.indice
                    }})</l-tooltip
                  >
                  <l-popup>
                    <ul>
                      <li>
                        <strong>Nombres:</strong>
                        {{ cliente.nombres_completos }}
                      </li>
                      <li>
                        <strong>Apellidos:</strong>
                        {{ cliente.apellidos_completos }}
                      </li>
                      <li>
                        <strong># Identificación:</strong>
                        {{ cliente.numero_identificacion }}
                      </li>
                      <li>
                        <strong>Dirección:</strong> {{ cliente.direccion }}
                      </li>
                      <li v-if="cliente.ultimo_pedido != null">
                        <strong>Número de venta:</strong>
                        {{ cliente.ultimo_pedido.numero_documento }}
                      </li>
                      <li v-if="cliente.ultimo_pedido != null">
                        <strong>Supervisor:</strong>
                        {{ cliente.ultimo_pedido.nombre_supervisor }}
                      </li>
                      <li v-if="cliente.ultimo_pedido != null">
                        <strong>Fecha de venta:</strong>
                        {{ cliente.ultimo_pedido.fecha }}
                      </li>
                      <li v-if="cliente.ultimo_pedido != null">
                        <strong>Día de cobro:</strong>
                        {{ cliente.ultimo_pedido.descripcion_dia_cobro }}
                      </li>
                      <li v-if="cliente.ultimo_pedido != null">
                        <strong>Total:</strong>
                        {{ moneyFormat(cliente.ultimo_pedido.venta_total) }}
                      </li>
                      <li v-if="cliente.ultimo_pedido != null">
                        <strong>Saldo:</strong>
                        {{ moneyFormat(cliente.ultimo_pedido.saldo) }}
                      </li>
                    </ul>
                    <center>
                      <button
                        @click="verVentas(cliente)"
                        type="button"
                        class="btn-info btn--text"
                      >
                        <i class="fa fa-table"></i><span>Ventas</span>
                      </button>
                    </center>
                  </l-popup>
                </l-marker>
                <l-polyline :weight="7" :key="index + polyline.color" v-for="(polyline, index) in polylines" :lat-lngs="polyline.latlngs" :color="polyline.color"></l-polyline>
                <l-polyline :weight="2" :key="index" v-for="(polyline, index) in polylines" :lat-lngs="polyline.latlngs" :color="'white'"></l-polyline>
              </l-map>
            </div>
          </div>
          <div class="col-xs-12">
            <div class="form-inline">
              <img src="/images/dias-cobro/1.png" alt="Lunes" /><label
                for="lunes"
                >Lunes</label
              >
              <img src="/images/dias-cobro/2.png" alt="Martes" /><label
                for="martes"
                >Martes</label
              >
              <img src="/images/dias-cobro/3.png" alt="Miércoles" /><label
                for="miercoles"
                >Miércoles</label
              >
              <img src="/images/dias-cobro/4.png" alt="Jueves" /><label
                for="jueves"
                >Jueves</label
              >
              <img src="/images/dias-cobro/5.png" alt="Viernes" /><label
                for="viernes"
                >Viernes</label
              >
              <img src="/images/dias-cobro/6.png" alt="Sábado" /><label
                for="sabado"
                >Sábado</label
              >
              <img src="/images/dias-cobro/7.png" alt="Domingo" /><label
                for="domingo"
                >Domingo</label
              >
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-2">
      <div class="col-md-4">
        <div class="card">
          <div class="card__title">
            <h5>Ventas por vendedor</h5>
          </div>
          <div class="card__content">
            <div style="max-height: 300px" class="table-responsive">
              <table>
                <thead>
                  <tr>
                    <th>Vendedor</th>
                    <th>Cant. Ventas</th>
                    <th>Tot. Ventas</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    :key="index"
                    v-for="(ventaVendedor, index) in ventasVendedor"
                  >
                    <td>
                      {{ ventaVendedor.nombre_vendedor }}
                    </td>
                    <td>
                      {{ ventaVendedor.cantidad_ventas }}
                    </td>
                    <td>
                      {{ moneyFormat(ventaVendedor.total_ventas) }}
                    </td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <th scope="row">
                      Totales
                    </th>
                    <td>
                      {{ calcularCantidadVentas(ventasVendedor) }}
                    </td>
                    <td>
                      {{ moneyFormat(calcularTotalVentas(ventasVendedor)) }}
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="card">
          <div class="card__title">
            <h5>Ventas por supervisor</h5>
          </div>
          <div class="card__content">
            <div style="max-height: 300px" class="table-responsive">
              <table>
                <thead>
                  <tr>
                    <th>Supervisor</th>
                    <th>Cant. Ventas</th>
                    <th>Tot. Ventas</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    :key="index"
                    v-for="(ventaSupervisor, index) in ventasSupervisor"
                  >
                    <td>
                      {{ ventaSupervisor.nombre_supervisor }}
                    </td>
                    <td>
                      {{ ventaSupervisor.cantidad_ventas }}
                    </td>
                    <td>
                      {{ moneyFormat(ventaSupervisor.total_ventas) }}
                    </td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <th scope="row">
                      Totales
                    </th>
                    <td>
                      {{ calcularCantidadVentas(ventasSupervisor) }}
                    </td>
                    <td>
                      {{ moneyFormat(calcularTotalVentas(ventasSupervisor)) }}
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="card">
          <div class="card__title">
            <h5>Ventas por recaudador</h5>
          </div>
          <div class="card__content">
            <div style="max-height: 300px" class="table-responsive">
              <table>
                <thead>
                  <tr>
                    <th>Recaudador</th>
                    <th>Cant. Ventas</th>
                    <th>Tot. Ventas</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    :key="index"
                    v-for="(ventaRecaudador, index) in ventasRecaudador"
                  >
                    <td>
                      {{ ventaRecaudador.nombre_recaudador }}
                    </td>
                    <td>
                      {{ ventaRecaudador.cantidad_ventas }}
                    </td>
                    <td>
                      {{ moneyFormat(ventaRecaudador.total_ventas) }}
                    </td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <th scope="row">
                      Totales
                    </th>
                    <td>
                      {{ calcularCantidadVentas(ventasRecaudador) }}
                    </td>
                    <td>
                      {{ moneyFormat(calcularTotalVentas(ventasRecaudador)) }}
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-xs-12 col-md-6">
        <div class="card">
          <div class="card__title">
            <h5>Comparación mensual</h5>
          </div>
          <div class="card__content">
            <line-chart :data="comparacionMensual"></line-chart>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <!-- <div class="card">
          <div class="card__title">
            <h5>Rangos de cuotas</h5>
          </div>
          <div class="card__content">
            <div class="table-responsive">
              <table>
                <thead>
                  <tr>
                    <th>Descripción</th>
                    <th>Desde</th>
                    <th>Hasta</th>
                    <th>Valor</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="rango in rangos" :key="rango.id">
                    <td>
                      {{ rango.descripcion }}
                    </td>
                    <td>
                      {{ moneyFormat(rango.desde) }}
                    </td>
                    <td>
                      {{ moneyFormat(rango.hasta) }}
                    </td>
                    <td>
                      {{ moneyFormat(rango.valor) }}
                    </td>
                  </tr>
                  <tr v-show="rangos.length === 0">
                    <td colspan="4">
                      <strong
                        >No se ha configurado los rangos de cuotas.</strong
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div> -->
        
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-xs-12 col-md-4">
        <div class="card">
          <div class="card__title">
            <h5>Productos vendidos</h5>
          </div>
          <div class="card__content">
            <k-table
              :mostrarTotales="false"
              :createButton="false"
              :deleteButton="false"
              :editButton="false"
              :path="pathProductosVendidos"
              :filterStatus="false"
              :params="form"
              :buscarButton="false"
              ref="productosVendidos"
              :columns="[
                {
                  display: 'Producto',
                  value: 'descripcion_item',
                },
                {
                  display: 'Cantidad',
                  value: 'cantidad',
                  numeric: true
                },
                {
                  display: 'Total',
                  value: 'total',
                  numeric: true,
                  prefijo: '$'
                }           
              ]"
            ></k-table>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-md-4">
        <div class="card">
          <div class="card__title">
            <h5>Premios entregados</h5>
          </div>
          <div class="card__content">
            <k-table
              :mostrarTotales="false"
              :createButton="false"
              :deleteButton="false"
              :editButton="false"
              :path="pathPremiosEntregados"
              :filterStatus="false"
              :params="form"
              :buscarButton="false"
              ref="premiosEntregados"
              :columns="[
                {
                  display: 'Producto',
                  value: 'descripcion_item',
                },
                {
                  display: 'Cantidad',
                  value: 'cantidad',
                  numeric: true
                },
                {
                  display: 'Total',
                  value: 'total',
                  numeric: true,
                  prefijo: '$'
                }            
              ]"
            ></k-table>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-md-4">
        <div class="card">
          <div class="card__title">
            <h5>Productos devueltos</h5>
          </div>
          <div class="card__content">
            <k-table
              :mostrarTotales="false"
              :createButton="false"
              :deleteButton="false"
              :editButton="false"
              :path="pathProductosDevueltos"
              :filterStatus="false"
              :params="form"
              :buscarButton="false"
              ref="productosDevueltos"
              :columns="[
                {
                  display: 'Producto',
                  value: 'descripcion_item',
                },
                {
                  display: 'Cantidad',
                  value: 'cantidad',
                  numeric: true
                },
                {
                  display: 'Total',
                  value: 'total',
                  numeric: true,
                  prefijo: '$'
                }          
              ]"
            ></k-table>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="card mt-2">
      <div class="card__title">
        <h5>Mapa de calor</h5>
      </div>
      <div class="card__content">
        <div class="row">
          <div class="col-xs-12 col-md-8">
            <div id="map"></div>
          </div>
          <div class="col-xs-12 col-md-4">
            <div class="table-responsive">
              <table>
                <thead>
                  <tr>
                    <th>Sector</th>
                    <th># Ventas</th>
                    <th>Abonos</th>
                    <th>Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-show="sectores.length === 0">
                    <td colspan="4">
                      <strong>No se ha encontrado sectores.</strong>
                    </td>
                  </tr>
                  <tr v-for="(sector, index) in sectores" :key="index">
                    <td>
                      {{ sector.descripcion_sector }}
                    </td>
                    <td>
                      {{ moneyFormat(sector.totalVentas) }} ({{
                        sector.ventas
                      }})
                    </td>
                    <td>
                      {{ moneyFormat(sector.totalAbonos) }} ({{
                        sector.abonos
                      }})
                    </td>
                    <td>
                      {{ moneyFormat(sector.valoresTotales) }} ({{
                        sector.numero_transacciones
                      }})
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <modal
      name="ventasDashboard"
      scrollable
      height="auto"
      width="75%"
      resizable
      adaptive
      reset
    >
      <ventas-dashboard
        :ventas="ventasCliente"
        @cerrar="cerrarVentas"
      ></ventas-dashboard>
    </modal>
  </div>
</template>

<script>
import VentasDashboard from "./VentasDashboard.vue";
import randomColor from 'randomcolor';
export default {
  props: {
    rangos: {
      type: Array,
      required: false,
      default: function () {
        return [];
      },
    },
    bodegas: {
      type: Array,
      required: false,
      default: function () {
        return [];
      },
    },
  },
  components: {
    VentasDashboard,
  },
  data: function () {
    return {
      pathPremiosEntregados: url + '/premios-entregados',
      pathProductosDevueltos: url + '/productos-devueltos',
      pathProductosVendidos: url + '/productos-vendidos',
      polylines: [],
      tooltipOptions: {
        permanent: true,
        //direction: 'bottom',
        opacity: 0.7
      },
      selectedBodega: null,
      ventasVendedor: [],
      ventasRecaudador: [],
      ventasSupervisor: [],
      comparacionMensual: [],
      clientIcon: L.icon({
        iconUrl: url + "/images/customer.png",
        iconAnchor: [16, 16],
      }),
      markerIcon: L.icon({
        iconUrl: url + "/images/place.png",
        iconAnchor: [16, 16],
      }),
      clientes: [],
      puntosRutas: [],
      selectedRutas: [],
      rutas: [],
      selectedVendedores: [],
      vendedores: [],
      selectedRecaudadores: [],
      recaudadores: [],
      selectedSupervisores: [],
      supervisores: [],
      form: {
        bodega_id: "",
        desde: moment(new Date()).format("YYYY-MM-DD"),
        hasta: moment(new Date()).format("YYYY-MM-DD"),
        tipo_fecha: "H",
        mostrar_clientes: true,
        mostrar_rutas: false,
        vendedores: [],
        supervisores: [],
        recaudadores: [],
        rutas: [],
        dia_cobro: "",
      },
      numeroVisitas: 0,
      numeroVentas: 0,
      numeroRecaudaciones: 0,
      numeroAbonos: 0,
      totalVentas: 0,
      totalAbonos: 0,
      sectores: [],
      moneyFormat: moneyFormat,
      heatmap: null,
      listenerAdded: false,
      defaultRadius: 42,
      localizaciones: [],
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      zoom: 18,
      center: [-2.1408961, -79.9080648],
      ventasCliente: [],
    };
  },
  methods: {
    calcularCantidadVentas: function (ventas) {
      let cantidadVentas = 0;
      for (let i = 0; i < ventas.length; i++) {
        cantidadVentas += parseFloat(ventas[i].cantidad_ventas);
      }
      return cantidadVentas;
    },
    calcularTotalVentas: function (ventas) {
      let total_ventas = 0;
      for (let i = 0; i < ventas.length; i++) {
        total_ventas += parseFloat(ventas[i].total_ventas);
      }
      return total_ventas;
    },
    verDireccion: function (comentario) {
      window.open(
        "https://maps.google.com?q=" +
          comentario.coordenadas_comentario.coordinates[1] +
          "," +
          comentario.coordenadas_comentario.coordinates[0],
        "_blank"
      );
    },
    inputBodega: function () {
      if (this.selectedBodega != null)
        this.form.bodega_id = this.selectedBodega.id;
      else this.form.bodega_id = "";
    },
    cerrarVentas: function () {
      this.$modal.hide("ventasDashboard");
    },
    verVentas: function (cliente) {
      let form = this.form;
      form.cliente_id = cliente.cliente_id;
      axios
        .get(url + "/ventas-dashboard", {
          params: form,
        })
        .then(({ data }) => {
          this.ventasCliente = data;
        });
      this.$modal.show("ventasDashboard");
    },
    inputRutas: function () {
      this.form.rutas.splice(0, this.form.rutas.length);
      for (let i = 0; i < this.selectedRutas.length; i++) {
        this.form.rutas.push(this.selectedRutas[i].id);
      }
    },
    inputRecaudadores: function () {
      this.form.recaudadores.splice(0, this.form.recaudadores.length);
      for (let i = 0; i < this.selectedRecaudadores.length; i++) {
        this.form.recaudadores.push(this.selectedRecaudadores[i].id);
      }
    },
    inputSupervisores: function () {
      this.form.supervisores.splice(0, this.form.supervisores.length);
      for (let i = 0; i < this.selectedSupervisores.length; i++) {
        this.form.supervisores.push(this.selectedSupervisores[i].id);
      }
    },
    inputVendedores: function () {
      this.form.vendedores.splice(0, this.form.vendedores.length);
      for (let i = 0; i < this.selectedVendedores.length; i++) {
        this.form.vendedores.push(this.selectedVendedores[i].id);
      }
    },
    searchVendedores: function (search, loading) {
      loading(true);
      let that = this;
      let xmlhttp = new XMLHttpRequest();
      xmlhttp.onreadystatechange = function () {
        if (
          (this.readyState == 4 && this.status == 200) ||
          this.status == 201
        ) {
          let json = JSON.parse(this.responseText);
          that.vendedores = json;
          loading(false);
        } else loading(false);
      };
      xmlhttp.open("GET", url + "/search/vendedores?search=" + search, true);
      xmlhttp.send();
    },
    searchRecaudadores: function (search, loading) {
      loading(true);
      let that = this;
      let xmlhttp = new XMLHttpRequest();
      xmlhttp.onreadystatechange = function () {
        if (
          (this.readyState == 4 && this.status == 200) ||
          this.status == 201
        ) {
          let json = JSON.parse(this.responseText);
          that.recaudadores = json;
          loading(false);
        } else loading(false);
      };
      xmlhttp.open(
        "GET",
        url + "/search/usuarios?tipo=R&search=" + search,
        true
      );
      xmlhttp.send();
    },
    searchSupervisores: function (search, loading) {
      loading(true);
      let that = this;
      let xmlhttp = new XMLHttpRequest();
      xmlhttp.onreadystatechange = function () {
        if (
          (this.readyState == 4 && this.status == 200) ||
          this.status == 201
        ) {
          let json = JSON.parse(this.responseText);
          that.supervisores = json;
          loading(false);
        } else loading(false);
      };
      xmlhttp.open(
        "GET",
        url + "/search/usuarios?tipo=S&search=" + search,
        true
      );
      xmlhttp.send();
    },
    onSearchRutas: function (search, loading) {
      loading(true);
      let that = this;
      let xmlhttp = new XMLHttpRequest();
      xmlhttp.onreadystatechange = function () {
        if (
          (this.readyState == 4 && this.status == 200) ||
          this.status == 201
        ) {
          let json = JSON.parse(this.responseText);
          that.rutas = json;
          loading(false);
        } else loading(false);
      };
      xmlhttp.open("GET", url + "/search/rutas?search=" + search, true);
      xmlhttp.send();
    },
    centerUpdated(center) {
      this.center = center;
    },
    zoomUpdated(zoom) {
      this.zoom = zoom;
    },
    generarPolylines: function () {
      this.polylines.splice(0, this.polylines.length);
      let supervisores = _.groupBy(this.clientes, 'ultimo_pedido.supervisor_id');
      for (let key in supervisores) {
        let polyline = {
          latlngs: [],
          color: randomColor()
        };
        for (let i = 0; i < supervisores[key].length; i++) {
          if (supervisores[key][i].latitud != null && supervisores[key][i].longitud) {
            polyline.latlngs.push([supervisores[key][i].latitud, supervisores[key][i].longitud]);
          }
        }
        this.polylines.push(polyline);
      }
    },
    obtenerIndicePorSupervisor: function (supervisorId) {
      let indice = 1;
      for (let i = 0; i < this.clientes.length; i++) {
        if (this.clientes[i].ultimo_pedido != null) {
          if (this.clientes[i].ultimo_pedido.supervisor_id == supervisorId) {
            indice++;
          }
        }
      }
      return indice;
    },
    obtenerSumaCoordenadas: function (latitud, longitud) {
      for (let i = 0; i < this.clientes.length; i++) {
        if (this.clientes[i].latitud == latitud && this.clientes[i].longitud == longitud) {
          return 0.000005;
        }
      }
      return 0;
    },
    consultar: function () {
      this.$refs.productosVendidos.loadRows();
      this.$refs.productosDevueltos.loadRows();
      axios
        .get(url + "/home", {
          params: this.form,
        })
        .then(({ data }) => {
          this.numeroVisitas = data.numeroVisitas;
          this.numeroVentas = data.numeroVentas;
          this.numeroRecaudaciones = data.numeroRecaudaciones;
          this.numeroAbonos = data.numeroAbonos;
          this.totalVentas = data.totalVentas;
          this.totalAbonos = data.totalAbonos;
          this.sectores = data.sectores;
          this.localizaciones = data.localizaciones;
          this.puntosRutas.splice(0, this.puntosRutas.length);
          this.clientes.splice(0, this.clientes.length);
          this.comparacionMensual = data.comparacionMensual;
          this.ventasVendedor = data.ventasVendedor;
          this.ventasSupervisor = data.ventasSupervisor;
          this.ventasRecaudador = data.ventasRecaudador;
          let indexCentral = parseInt(data.pedidos.length / 2);
          for (let i = 0; i < data.pedidos.length; i++) {
            if (data.pedidos[i].cliente.coordenadas_cliente != null) {
              let indice = data.pedidos[i].cliente.ultimo_pedido != null?this.obtenerIndicePorSupervisor(data.pedidos[i].cliente.ultimo_pedido.supervisor_id):0;
              let sumaCoords = this.obtenerSumaCoordenadas(data.pedidos[i].cliente.coordenadas_cliente.coordinates[1], data.pedidos[i].cliente.coordenadas_cliente.coordinates[0]);
              this.clientes.push({
                indice: indice,
                saldo: data.pedidos[i].cliente.saldo,
                cliente_id: data.pedidos[i].cliente_id,
                nombres_completos: data.pedidos[i].cliente.nombres_completos,
                apellidos_completos:
                  data.pedidos[i].cliente.apellidos_completos,
                numero_identificacion:
                  data.pedidos[i].cliente.numero_identificacion,
                direccion: data.pedidos[i].cliente.direccion,
                latitud:
                  data.pedidos[i].cliente.coordenadas_cliente.coordinates[1] + sumaCoords + (sumaCoords > 0?(indice / 10000):0),
                longitud:
                  data.pedidos[i].cliente.coordenadas_cliente.coordinates[0] + sumaCoords + (sumaCoords > 0?(indice / 10000):0),
                ultimo_pedido: data.pedidos[i].cliente.ultimo_pedido,
                icon:
                  data.pedidos[i].cliente.ultimo_pedido != null
                    ? L.icon({
                        iconUrl:
                          url +
                          "/images/dias-cobro/" +
                          data.pedidos[i].cliente.ultimo_pedido.dia_cobro +
                          ".png",
                        iconAnchor: [16, 16],
                      })
                    : this.clientIcon,
              });
              if (i == indexCentral) {
                this.center = [
                  data.pedidos[i].cliente.coordenadas_cliente.coordinates[1],
                  data.pedidos[i].cliente.coordenadas_cliente.coordinates[0],
                ];
                this.zoom = 11;
              }
            }
          }
          this.generarPolylines();
          for (let i = 0; i < data.rutas.length; i++) {
            for (let j = 0; j < data.rutas[i].geocercas.length; j++) {
              this.puntosRutas.push({
                ruta_id: data.rutas[i].id,
                radio: data.rutas[i].geocercas[j].radio,
                descripcion: data.rutas[i].geocercas[j].descripcion,
                nombre_ruta: data.rutas[i].nombre,
                latitud:
                  data.rutas[i].geocercas[j].coordenadas_geocerca
                    .coordinates[1],
                longitud:
                  data.rutas[i].geocercas[j].coordenadas_geocerca
                    .coordinates[0],
              });
            }
          }
          // if (map != null) {
          //   let that = this;
          //   if (!that.listenerAdded) {
          //     google.maps.event.addListener(map, "zoom_changed", function () {
          //       that.listenerAdded = true;
          //       let zoom = map.getZoom();
          //       if (zoom > 10) {
          //         zoom = zoom * 3;
          //       }
          //       that.heatmap.setOptions({ radius: zoom * 6 });
          //     });
          //   }
          //   if (that.heatmap != null) {
          //     that.heatmap.setMap(null);
          //   }
          //   let heatMapData = [];
          //   Object.keys(that.localizaciones).forEach(function (key) {
          //     let item = that.localizaciones[key];
          //     heatMapData.push({
          //       location: new google.maps.LatLng(
          //         parseFloat(item.latitud_venta),
          //         parseFloat(item.longitud_venta)
          //       ),
          //       weight: parseFloat(item.numero_pedidos),
          //     });
          //   });
          //   that.heatmap = new google.maps.visualization.HeatmapLayer({
          //     data: heatMapData,
          //   });
          //   that.heatmap.setOptions({
          //     radius: that.defaultRadius,
          //   });
          //   that.heatmap.setMap(map);
          // }
        });
    },
  },
  mounted: function () {
    const map = this.$refs.mymap.mapObject;
    map.addControl(new L.Control.Fullscreen());
    this.consultar();
  },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/general/Dashboard.vue